import {
  TOOTH_BASIS_SERIES_CACHE_LIMIT,
  type FullHeadMprSavedViewTiles,
} from '../config';

const tilesByToothID = new Map<string, FullHeadMprSavedViewTiles>();

export const getFullHeadMprSavedViewTiles = (toothID: string) =>
  tilesByToothID.get(toothID) ?? {};

export const putFullHeadMprSavedViewTiles = (
  toothID: string,
  tiles: FullHeadMprSavedViewTiles,
) => {
  tilesByToothID.delete(toothID);
  tilesByToothID.set(toothID, tiles);
  [...tilesByToothID.keys()]
    .slice(0, Math.max(0, tilesByToothID.size - TOOTH_BASIS_SERIES_CACHE_LIMIT))
    .forEach((key) => tilesByToothID.delete(key));
};

export const clearFullHeadMprSavedViewTiles = () => tilesByToothID.clear();
